import React from 'react'
import { useToggle } from 'react-use'

export function useRetryAsync(asyncFn: () => Promise<any>) {
  const [isRetrying, setIsRetrying] = useToggle(false)

  const doRetry = React.useCallback(async () => {
    if (isRetrying) {
      return
    }

    setIsRetrying(true)
    await asyncFn()
    setIsRetrying(false)
  }, [isRetrying, setIsRetrying, asyncFn])

  return { isRetrying, doRetry }
}
